import React from "react";

const DetailIcon = (props) => {
    return(
        <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" fill={props.fill}><path d="M12.366 24.875l2.142-2.142c.709.488 1.567.776 2.493.776 2.43 0 4.4-1.97 4.4-4.4 0-2.43-1.97-4.4-4.4-4.4-2.43 0-4.4 1.97-4.4 4.4 0 .926.288 1.784.776 2.493l-2.142 2.142 1.131 1.131zm1.834-5.766c0-1.546 1.254-2.8 2.8-2.8 1.546 0 2.8 1.254 2.8 2.8 0 1.546-1.254 2.8-2.8 2.8-1.546 0-2.8-1.254-2.8-2.8zM9.607 23.11l1.808-1.808c-.273-.693-.415-1.434-.415-2.192 0-3.308 2.692-6 6-6 1.177 0 2.273.346 3.2.933v-10.533c0-.442-.358-.8-.8-.8h-16c-.442 0-.8.358-.8.8v18.8c0 .442.358.8.8.8h6.206zm7.794-13.2h-12v-1.6h12v1.6zm0-3.2h-12v-1.6h12v1.6z"/><clipPath><path fill="#fff" d="M0 .875h24v24h-24z"/></clipPath></svg>
    )
}

export default DetailIcon;
